import styled, { css } from "styled-components";
import { colors } from "../../styles/colors";

export const StyledCalendarWrapper = styled.div`
  max-width: calc(100vw - 40px);

  .react-calendar {
    border: none;
    font-family: inherit;
    background: transparent;

    &__navigation {
      display: flex;
      align-items: center;
      background-color: #3a3a38;
      border-radius: 5px 5px 0 0;
      margin-bottom: 0;
      height: 44px;
      padding: 0 4px;

      button {
        color: white;
        background: transparent;
        border: none;
        border-radius: 4px;
        font-size: 0.95rem;
        font-weight: 600;
        min-width: 36px;
        transition: background-color 0.15s ease;

        &:enabled:hover,
        &:enabled:focus {
          background-color: rgba(255, 255, 255, 0.12);
        }
        &:disabled {
          opacity: 0.35;
        }
      }
    }

    &__navigation__prev2-button,
    &__navigation__next2-button {
      display: none;
    }

    &__month-view {
      background: white;
      border: 1px solid #e8e8e8;
      border-top: none;
      border-radius: 0 0 5px 5px;
      padding: 10px;

      &__weekdays {
        display: grid !important;
        grid-template-columns: repeat(7, 1fr);
        grid-gap: 8px;
        margin-bottom: 4px;

        &__weekday {
          color: ${colors.textColorSecondary};
          font-size: 0.75rem;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          width: 100%;
          max-width: none !important;
          text-align: center;

          abbr[title] {
            border-bottom: none;
            text-decoration: none;
            cursor: default;
          }
        }
      }

      &__days {
        display: grid !important;
        grid-template-columns: repeat(7, 1fr);
        grid-gap: 6px;
        justify-items: center;

        &__day {
          background-color: #f8f8f8;
          color: ${colors.textColor};

          &--weekend {
            background-color: #f8f8f8;
            color: ${colors.textColorSecondary};

            &:disabled {
              color: #ccc !important;
              background-color: #f4f4f4 !important;
            }
          }
        }

        &__day--neighboringMonth {
          background-color: transparent;
          color: #ccc;
          border-color: transparent !important;

          &.react-calendar__tile:disabled {
            background-color: transparent;
            border-color: transparent !important;
          }
        }
      }

      .react-calendar__tile {
        border: 1px solid #e8e8e8;
        border-radius: 6px;
        padding: 5px 4px;
        width: 100%;
        max-width: none !important;
        font-size: 0.85rem;
        font-weight: 500;
        display: flex;
        justify-content: center;
        transition: background-color 0.12s ease, border-color 0.12s ease;

        &--now {
          border-color: #3b82f6 !important;
          background-color: #eff6ff;

          & > abbr {
            color: #1e40af;
            font-weight: 700;
          }
        }

        &:disabled {
          color: #bbb;
          background-color: #f4f4f4;
          border-color: transparent;
          cursor: not-allowed;
          box-shadow: none !important;
        }

        &:enabled:hover {
          background-color: #dbeafe;
          border-color: #93c5fd;
          color: #1e40af;
        }

        ${(props) =>
          props.defaultActiveDisabled
            ? css`
                &--active {
                  background-color: #f8f8f8;
                  border-color: #e8e8e8;
                  color: ${colors.textColor};
                  box-shadow: none;
                }
              `
            : css`
                &--active {
                  background-color: #3b82f6;
                  border-color: #2563eb;
                  color: white;
                  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.25);

                  &:focus {
                    background-color: #3b82f6;
                  }
                }
              `}

        &--custom-active {
          background-color: #3b82f6 !important;
          border-color: #2563eb !important;
          color: white !important;
          box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.25) !important;

          &:focus {
            background-color: #3b82f6 !important;
          }
        }
      }
    }
  }

  .react-calendar__tile--blocked {
    background-color: #fecaca !important;
    border-color: #fca5a5 !important;
    color: #991b1b !important;
    cursor: pointer !important;
  }

  .react-calendar__tile--blocked:hover {
    filter: brightness(0.93);
  }

  .react-calendar__tile--custom-active {
    background-color: #3b82f6 !important;
    border-color: #2563eb !important;
    color: white !important;
  }
`;
